var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFemale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M50.9-104.932a25,25,0,0,1-25,25,25,25,0,0,1-25-25,25,25,0,0,1,25-25,25,25,0,0,1,25,25",
    transform: "translate(-0.895 129.932)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M59.916-95.772c0,6.943-4.354,12.572-9.725,12.572s-9.725-5.629-9.725-12.572,4.354-12.572,9.725-12.572,9.725,5.629,9.725,12.572",
    transform: "translate(-40.465 108.344)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M35.83-40.789c-7.825,0-14.715,2.825-18.753,7.112A24.933,24.933,0,0,0,35.83-25.2a24.933,24.933,0,0,0,18.753-8.477c-4.038-4.287-10.929-7.112-18.753-7.112",
    transform: "translate(-17.077 40.789)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M59.35-49.292H58a3.727,3.727,0,0,1-3.715-3.715v-8.446A3.726,3.726,0,0,1,58-65.169H59.35a3.727,3.727,0,0,1,3.715,3.715v8.446a3.727,3.727,0,0,1-3.715,3.715",
    transform: "translate(-54.283 65.169)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M38.589-78.193c.566,1.631.342,3.19-.5,3.482S36.1-75.5,35.535-77.133s-.341-3.19.5-3.482,1.986.791,2.552,2.422",
    transform: "translate(-35.223 80.663)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M86.876-78.193c-.566,1.631-.342,3.19.5,3.482s1.986-.791,2.552-2.422.342-3.19-.5-3.482-1.986.791-2.552,2.422",
    transform: "translate(-86.564 80.663)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M56.883-98.883c-.213-3.1-.108-6.29-1.106-9.237a11.989,11.989,0,0,0-6.985-7.361,10.418,10.418,0,0,0-9.927,1.458,3.832,3.832,0,0,0-1.726,3.076c-1.663-.563-3.517.618-4.295,2.193a10.174,10.174,0,0,0-.628,5.167c.324,5.136,1.107,10.4-.283,15.349l12.786.387c1.365.041,2.731.083,4.095.024,3.48-.15,7.087-.934,10.365.246a43.98,43.98,0,0,1-2.3-11.3",
    transform: "translate(-31.934 116.129)",
    fill: "none",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "female-50px",
    transform: "translate(-0.895 129.932)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(0.895 -129.932)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M-.1-130.932H50.667V-80.16H-.1Z",
    transform: "translate(-0.281 130.546)",
    fill: "#b4bdd3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(16.17 -121.599)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M39.465-109.344H59.688v25.916H39.465Z",
    transform: "translate(-39.851 108.958)",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(7.142 -95.521)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M16.077-41.789H54.356v16.361H16.077Z",
    transform: "translate(-16.463 41.403)",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(21.504 -104.932)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M53.283-66.169h9.554V-49.52H53.283Z",
    transform: "translate(-53.669 65.783)",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(14.146 -110.913)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M33.566-82.3h4.958v7.262H33.566Z",
    transform: "translate(-34.206 81.667)",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(33.965 -110.913)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M84.906-82.3h4.958v7.262H84.906Z",
    transform: "translate(-85.546 81.667)",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(12.877 -124.604)",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M30.934-118.6H58.952v29.889H30.934Z",
    transform: "translate(-31.32 117.648)",
    fill: "#fffefe"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.f6fe776e2b4752015513bb761713df29.svg";
export { ForwardRef as ReactComponent };